import {Container} from "./Container";
import {Text} from "./Text";
import {colors} from "../theme";

type AvatarProps = {
  name: string;
  size?: number;
};

export const Avatar = ({name, size = 48}: AvatarProps) => {
  const initials = name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);

  const fontSize = size <= 32 ? "body-medium" : "display-medium";

  return (
    <Container
      center
      sx={{
        width: size,
        height: size,
        borderRadius: "50%",
        backgroundColor: colors.primary[100],
        flexShrink: 0,
      }}
    >
      <Text variant={fontSize} color={colors.primary[800]}>
        {initials}
      </Text>
    </Container>
  );
};
